import { dev, prod, local } from './env';

// react-scripts sets NODE_ENV to production on build, so can't use that
export const env = process.env.FUJI_UI_ENV || 'LOCAL';

// GET CONFIG BASED ON ENV
let config = local;
if (env === 'PRODUCTION') config = prod;
else if (env === 'DEV') config = dev;

// CONFIG VARIABLES
export const envDisplay = config.envDisplay;
export const signInUrl = config.signInUrl;
export const signOutUrl = config.signOutUrl;
export const sendResetPasswordEmail = config.sendResetPasswordEmail;
export const resetPassword = config.resetPassword;
export const deleteOrgUrl = config.deleteOrgUrl;
export const addDevicesUrl = config.addDevicesUrl;
export const listDevicesUrl = config.listDevicesUrl;
export const listFirmwaresUrl = config.listFirmwaresUrl;
export const listIotAgentUrl = config.listIotAgentUrl;
export const uploadFirmwareUrl = config.uploadFirmwareUrl;
export const deleteFirmwareBlobUrl = config.deleteFirmwareBlobUrl;
export const deleteIotAgentBlobUrl = config.deleteIotAgentBlobUrl;
export const uploadIotAgentUrl = config.uploadIotAgentUrl;
export const createGroupUrl = config.createGroupUrl;
export const editGroupUrl = config.editGroupUrl;
export const sendInviteEmailUrl = config.sendEmailUrl;
export const verifyEmailAddressUrl = config.verifyEmailAddressUrl;
export const registerOrgUrl = config.registerOrgUrl;
export const generatePublicApiTokenUrl = config.generatePublicApiTokenUrl;
export const listGroupsUrl = config.listGroupsUrl;
export const listPublicApiTokensUrl = config.listPublicApiTokensUrl;
export const revokePublicApiTokenUrl = config.revokePublicApiTokenUrl;
export const getPublicApiApprovalStatusUrl = config.getPublicApiApprovalStatusUrl;
export const getlicensesUrl = config.getLicensesUrl;
export const addOrManageMobileLicenseUrl = config.addOrManageMobileLicenseUrl;
export const revokeMobileLicenseUrl = config.revokeMobileLicenseUrl;
export const listOrganizationsUrl = config.listOrganizationsUrl;
export const getOrgTemplatesUrl = config.getOrgTemplatesUrl;
export const putOrgTemplatesUrl = config.putOrgTemplatesUrl;
export const getTemplatesUrl = config.getTemplatesUrl;
export const addTemplateUrl = config.addTemplateUrl;
export const updateTemplateUrl = config.updateTemplateUrl;
export const generateDeviceReportUrl = config.generateDeviceReportUrl;
export const deleteOrganizationUrl = config.deleteOrganizationUrl;
export const updateOrganizationUrl = config.updateOrganizationUrl;
export const updateOrganizationExecutablesUrl =
  config.updateOrganizationExecutablesUrl;
export const updateOrgStatusUrl = config.updateOrgStatusUrl;
export const listAlertsUrl = config.listAlertsUrl;
export const listUserUrl = config.listUserUrl;
export const deleteUserUrl = config.deleteUserUrl;
export const updateUserUrl = config.updateUserUrl;
export const createUserUrl = config.createUserUrl;
export const inviteUserUrl = config.inviteUserUrl;
export const verifyUserInvitationTokenUrl = config.verifyUserInvitationTokenUrl;
export const getMobileLicenseUsersUrl = config.getMobileLicenseUsersUrl;
export const manageMobileLicenseUsersUrl = config.manageMobileLicenseUsersUrl;
export const deleteAlertUrl = config.deleteAlertUrl;
export const createAlertUrl = config.createAlertUrl;
export const createDasAlertUrl = config.createDASAlertUrl;
export const sendDasAlertUrl = config.sendDASAlertUrl;
export const editAlertUrl = config.editAlertUrl;
export const listAlerTypestUrl = config.listAlerTypestUrl;
export const endAlertUrl = config.endAlertUrl;
export const listApprovalAlertUrl = config.listApprovalAlertUrl;
export const approveAlertUrl = config.approveAlertUrl;
export const denyAlertUrl = config.denyAlertUrl;
export const roleIds = config.roleIds;
export const deleteDeviceUrl = config.deleteDeviceUrl;
export const pendingDeletionsUrl = config.pendingDeletionsUrl;
export const forceDeleteDeviceUrl = config.forceDeleteDeviceUrl;
export const updateDeviceUrl = config.updateDeviceUrl;
export const unassignDeviceUrl = config.unassignDeviceUrl;
export const assignDevicesUrl = config.assignDevicesUrl;
export const listDasSubscriptionsUrl = config.listDasSubscriptionsUrl;
export const deleteSubscriptionsUrl = config.deleteSubscriptionsUrl;
export const editSubscriptionUrl = config.editSubscriptionUrl;
export const apimSubscriptionKey = config.apimSubscriptionKey;
export const acquireTokenUrl = config.acquireTokenUrl;
export const resendAlertUrl = config.resendAlertUrl;
export const dashboardDetailsUrl = config.dashboardDetailsUrl;
export const alertActionUrl = config.alertActionUrl;
export const deviceLogUrl = config.deviceLogUrl;
export const configureSinglewireTokenUrl = config.configureSinglewireTokenUrl;
export const singlewireWebhookURL = config.singlewireWebhookURL;
export const listSinglewireSiteUrl = config.listSinglewireSiteUrl;
export const mapSinglewireSitesUrl = config.mapSinglewireSitesUrl;
export const mapEverbridgeGroupsUrl = config.mapEverbridgeGroupsUrl;
export const configureEverbridgeTokenUrl = config.configureEverbridgeTokenUrl;
export const listEverbridgeGroupUrl = config.listEverbridgeGroupUrl;
export const getIntegrationWebhookStatusUrl = config.getIntegrationWebhookStatusUrl;
export const everbridgeWebhookURL = config.everbridgeWebhookURL;
export const alertusWebhookURL = config.alertusWebhookURL;
export const generateAlertusTokenUrl = config.generateAlertusTokenUrl;
export const listAlertusTokensUrl = config.listAlertusTokensUrl;
export const revokeAlertusTokenUrl = config.revokeAlertusTokenUrl;
export const quickAlertsUrl = config.quickAlertsUrl;
export const listQuickAlertsUrl = config.listQuickAlertsUrl;
export const createQuickAlertsUrl = config.createQuickAlertsUrl;
export const deleteQuickAlertsUrl = config.deleteQuickAlertsUrl;
export const editQuickAlertsUrl = config.editQuickAlertsUrl;
export const sendQuickAlertsUrl = config.sendQuickAlertsUrl;
export const saveQuickAlertsOrderUrl = config.saveQuickAlertsOrderUrl;
export const firebaseConfig = config.firebaseConfig;
export const approvePublicApiUserUrl = config.approvePublicApiUserUrl;
export const createCapEndpointUrl = config.createCapEndpointUrl;
export const listCapEndpointsUrl = config.listCapEndpointsUrl;
export const updateCapEndpointUrl = config.updateCapEndpointUrl;
export const deleteCapEndpointUrl = config.deleteCapEndpointUrl;
export const regenerateCapEndpointTokenUrl = config.regenerateCapEndpointTokenUrl;
export const capWebhookURL = config.capWebhookURL;
export const rebootDeviceUrl = config.rebootDeviceUrl;
export const organizationsAnalyticsUrl = config.getOrganizationsAnalyticsUrl;
export const superAdminDeviceAnalyticsUrl = config.getSuperAdminDeviceAnalyticsUrl;
export const thirdPartyIntegrationStatsUrl = config.getThirdPartyIntegrationStatsUrl;
export const getWebhookMigrationConfigUrl = config.getWebhookMigrationConfigUrl;
export const updateWebhookMigrationConfigUrl = config.updateWebhookMigrationConfigUrl;
export const triggerWebhookUrlUpdateReminderUrl = config.triggerWebhookUrlUpdateReminderUrl;
export const alertsStatsUrl = config.getAlertsStatsUrl;
export const versionDistributionUrl = config.getVersionDistributionUrl;
export const userCountAndDetailsUrl = config.getUserCountAndDetailsUrl;
export const getAlertDetailsUrl = config.getAlertDetailsUrl;
export const getHelpGuidesUrl = config.getHelpGuidesUrl;
export const addHelpGuideUrl = config.addHelpGuideUrl;
export const editHelpGuideUrl = config.editHelpGuideUrl;
export const deleteHelpGuideUrl = config.deleteHelpGuideUrl;
